import { Encoding } from '@mode-vegas/vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const chartDesignerExportCsv = createAction(
  '[Chart Designer] ExportCsv',
  props<{
    token: string;
    refId: string;
  }>()
);

export const viewDataChartExportCsv = createAction('[View Data] ExportCsv');

export const chartExportCsvPlan = createAction(
  '[File Export] chartExportCsvPlan',
  props<{
    token: string;
    refId: string;
    plan: FlamingoTypes.ModeExportPlan;
    queryRunToken: string;
    switchViewToken: string;
    filename: string;
    rowCount: number;
    datasetColumnCount: number;
    datasetRowCount: number;
  }>()
);

export const chartExportCsvSuccess = createAction(
  '[File Export] ChartExportCsvSuccess',
  props<{ id: string; urlOrBlob: string | Readonly<Blob>; token: string; refId: string }>()
);

export const chartExportCsvFailed = createAction(
  '[File Export] ChartExportCsvFailed',
  props<{ id: string; error: Error; token: string; refId: string }>()
);

export const downloadExport = createAction('[Export List] DownloadExport', props<{ id: string }>());
export const downloadExportSuccess = createAction(
  '[Export List] DownloadExportSuccess',
  props<{ id: string; downloadSize: number }>()
);
export const downloadExportFailed = createAction(
  '[Export List] DownloadExportFailed',
  props<{ id: string; error: Error }>()
);

export const chartReportExportCsv = createAction(
  '[Report Viewer] ExportCsv',
  props<{
    token: string;
  }>()
);

export const deleteExport = createAction('[Export List] DeleteExport', props<{ id: string }>());

export const retryExport = createAction('[Export List] RetryExport', props<{ id: string }>());

export const retryChartExportPlan = createAction(
  '[Export List] RetryChartExportPlan',
  props<{ token: string; refId: string; plan: FlamingoTypes.ModeExportPlan; queryRunToken: string }>()
);

export const retryExportSuccess = createAction(
  '[Export List] RetryExportSuccess',
  props<{ id: string; urlOrBlob: string | Readonly<Blob>; token: string; refId: string }>()
);

export const retryExportFailed = createAction(
  '[Export List] RetryExportFailed',
  props<{ id: string; error: Error; token: string; refId: string }>()
);
